import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ContactForm extends Component {

    componentDidMount() {
        const $ = window.$;
        const form = $('#contact-form');
        const formMessages = $('.form-messege');

        $(form).submit(function (e) {
            e.preventDefault();

            const formData = {
                access_key: 'ee27ccce-8126-4b08-a52e-ea7d5c93914c', // ← Remplace par ta clé Web3Forms
                name: $('input[name="name"]').val(),
                email: $('input[name="email"]').val(),
                subject: $('input[name="subject"]').val(),
                phone: $('input[name="phone"]').val(),
                message: $('textarea[name="message"]').val()
            };

            fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(formData)
            })
            .then(async (response) => {
                let json = await response.json();
                if (response.status === 200) {
                    formMessages.removeClass('error').addClass('success').text("Message envoyé avec succès !");
                    $('#contact-form input,#contact-form textarea').val('');
                } else {
                    formMessages.removeClass('success').addClass('error').text(json.message || "Une erreur est survenue.");
                }
            })
            .catch(() => {
                formMessages.removeClass('success').addClass('error').text("Erreur de réseau ou serveur.");
            });
        });
    }

    render() {
        return (
            <div className="ltn__contact-message-area mb-120 mb--100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__form-box contact-form-box box-shadow white-bg">
                                <h4 className="title-2">Contact</h4>
                                <form id="contact-form">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input-item input-item-name ltn__custom-icon">
                                                <input type="text" name="name" placeholder="Enter your name" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-item input-item-email ltn__custom-icon">
                                                <input type="email" name="email" placeholder="Enter email address" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-item input-item-subject ltn__custom-icon">
                                                <input type="text" name="subject" placeholder="Enter subject" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input-item input-item-phone ltn__custom-icon">
                                                <input type="text" name="phone" placeholder="Enter phone number" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="input-item input-item-textarea ltn__custom-icon">
                                        <textarea name="message" placeholder="Enter message" required />
                                    </div>
                                    <div className="btn-wrapper mt-0">
                                        <button className="btn theme-btn-1 btn-effect-1 text-uppercase contact-button" type="submit">Envoyer</button>
                                    </div>
                                    <p className="form-messege mb-0 mt-20" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactForm;
